import * as React from "react";
import {ThemeProvider} from "theme-ui";
import theme from "./theme";

const UIKitProvider: React.FC = ({children}) => {
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
};

export default UIKitProvider;
